import { styled } from "@mui/material";
import { Button, Notification } from "@pmag/ui-components";

export const StyledButton = styled(Button)(({ theme }) => ({
    [theme.breakpoints.down("md")]: {
        paddingRight: 0,
    },
}));

export const StyledNotification = styled(Notification)(({ theme }) => ({
    [theme.breakpoints.down("md")]: {
        width: 300,
    },
}));
